import { gql } from '@apollo/client';

export const GET_DEVICE_CONFIGURATION_EXECUTION_STATE = gql`
  query GetDeviceConfigurationExecutionState($deviceId: ID!) {
    retrieveDeviceConfigurationExecutionState(input: { deviceId: $deviceId }) {
      status
    }
  }
`;
